import { render, staticRenderFns } from "./CadastrarTecnicoExame.vue?vue&type=template&id=0b4f6142&scoped=true"
import script from "./CadastrarTecnicoExame.vue?vue&type=script&lang=js"
export * from "./CadastrarTecnicoExame.vue?vue&type=script&lang=js"
import style0 from "./CadastrarTecnicoExame.vue?vue&type=style&index=0&id=0b4f6142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f6142",
  null
  
)

export default component.exports